/**
 * Created by zoechodosh on 3/22/17.
 */
import fetch from 'isomorphic-fetch';
import { toastsActions } from '@zola-helpers/client';

import { updateEntityRequest, receiveEntityResponse, receiveUpdatedEntityResponse, getEntitiesRequest, getEntitiesResponse, editEntityRequest } from '../EntityActions';

const ENTITY_LIST_NAME = 'photos';

// TODO: MOVE THIS AND USE FOR ALL REQUESTS!!!!
function handleErrors(response) {
  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return response;
}

export function getPhotos() {
  return (dispatch) => {
    dispatch(getEntitiesRequest());
    return fetch('/web-api/v1/cms/page/photo',
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(getEntitiesResponse(json, ENTITY_LIST_NAME)));
  };
}

export const editPhoto = photo => (dispatch) => {
  dispatch(editEntityRequest(photo));
};

export function addPhoto(createPhotoRequest) {
  return (dispatch) => {
    dispatch(updateEntityRequest());
    return fetch('/web-api/v1/cms/page/photo/create',
      {
        credentials: 'same-origin',
        headers: {
          'Content-type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(createPhotoRequest)
      })
      .then(handleErrors)
      .then(response => response.json())
      .then((json) => {
        dispatch(toastsActions.positive({ headline: 'Photo Added' }));
        return json;
      })
      .then(json => dispatch(receiveEntityResponse(json)));
  };
}

export function updatePhoto(updatedPhotoRequest) {
  return (dispatch) => {
    dispatch(updateEntityRequest());
    return fetch('/web-api/v1/cms/page/photo/update',
      {
        credentials: 'same-origin',
        headers: {
          'Content-type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(updatedPhotoRequest)
      })
      .then(handleErrors)
      .then(response => response.json())
      .then((json) => {
        dispatch(toastsActions.positive({ headline: 'Photo Updated' }));
        return json;
      })
      .then(json => dispatch(receiveUpdatedEntityResponse(json)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/website/entities/PhotosActions.js